import Vue from "vue";
let currentRequest = 0;
const CustomerService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("customer", id, {
        include: "customer_type,links,tenant"
      });
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      searchFilterPagination.include = "tenant,agreement,agreement.services"
      const request = ++currentRequest;
      console.log(`[${request}] START CUSTOMER `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "customers",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] CUSTOMER DISCARDED`);
        return null;
      }
      console.log(`[${request}] END CUSTOMER `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  },
  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null) {
        return await Vue.$jsonApi.create("customer", payload);
      } else {
        return await Vue.$jsonApi.update("customer", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },
  async delete(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.destroy("customer", id);
      return data;
    } catch (error) {
      console.log("delete error: ", error);
      return { error: error };
    }
  }
};

export { CustomerService };
